import * as React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography';
import { createTheme } from '@mui/material/styles';
import { Trans, useTranslation } from "react-i18next";
import { Title } from '../../../components/Title';
import { SmartButtonRounded } from '@mui/icons-material';


import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';



const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: (theme.vars ?? theme).palette.text.secondary,
}));

export default function WieIstDieGem() {

  const { t } = useTranslation();

  return (
    <>

      <Box id="consultation" sx={{
        color: 'white',
        /*backgroundColor: '#00652b',*/
      }} className='maintextbox' >

        <Title title="municipalities_advice" variant="title"></Title>

        <Box className='pad' />

        <Box sx={{ flexGrow: 1 }}>

          <Grid container className="box1">

            <Grid item className="box2" xs={12} sm={12} md={4}>

              <div className="arr">
                <Trans
                  i18nKey="municipalities_t1"
                  components={{ italic: <i />, strong: <strong /> }}
                />
              </div>

            </Grid>

            <Grid item className="box3" xs={12} sm={12} md={8}>

              <div className="arrinfo">
                <ul>
                  <li>
                    <Trans
                      i18nKey="municipalities_t1_p1"
                      components={{ italic: <i />, strong: <strong /> }}
                    />
                  </li>
                  <li>
                    <Trans
                      i18nKey="municipalities_t1_p2"
                      components={{ italic: <i />, strong: <strong /> }}
                    />
                  </li>
                  <li>
                    <Trans
                      i18nKey="municipalities_t1_p3"
                      components={{ italic: <i />, strong: <strong /> }}
                    />
                  </li>
                </ul>
              </div>

            </Grid>

          </Grid>



          <Grid container className="box1">

            <Grid item className="box2" xs={12} sm={12} md={4}>

              <div className="arr">
                <Trans
                  i18nKey="municipalities_t2"
                  components={{ italic: <i />, strong: <strong /> }}
                />
              </div>
            </Grid>

            <Grid item className="box3" xs={12} sm={12} md={8}>
              <div className="arrinfo">
                <ul>
                  <li>
                    <Trans
                      i18nKey="municipalities_t2_p1"
                      components={{ italic: <i />, strong: <strong /> }}
                    />
                  </li>
                  <li>
                    <Trans
                      i18nKey="municipalities_t2_p2"
                      components={{ italic: <i />, strong: <strong /> }}
                    />
                  </li>
                  <li>
                    <Trans
                      i18nKey="municipalities_t2_p3"
                      components={{ italic: <i />, strong: <strong /> }}
                    />
                  </li>
                </ul>
              </div>
            </Grid>

          </Grid>



          <Grid container className="box1">
            <Grid item className="box2" xs={12} sm={12} md={4}>
              <div className="arr">
                <Trans
                  i18nKey="municipalities_t3"
                  components={{ italic: <i />, strong: <strong /> }}
                />
              </div>

            </Grid>

            <Grid item className="box3" xs={12} sm={12} md={8}>
              <div className="arrinfo">
                <ul>
                  <li>
                    <Trans
                      i18nKey="municipalities_t3_p1"
                      components={{ italic: <i />, strong: <strong /> }}
                    />
                  </li>
                  <li>
                    <Trans
                      i18nKey="municipalities_t3_p2"
                      components={{ italic: <i />, strong: <strong /> }}
                    />
                  </li>
                  <li>
                    <Trans
                      i18nKey="municipalities_t3_p3"
                      components={{ italic: <i />, strong: <strong /> }}
                    />
                  </li>
                  <li>
                    <Trans
                      i18nKey="municipalities_t3_p4"
                      components={{ italic: <i />, strong: <strong /> }}
                    />
                  </li>
                </ul>
              </div>
            </Grid>

          </Grid>

          <Grid container className="box1">

            <Grid item className="box2" xs={12} sm={12} md={4}>
              <div className="arr">
                <Trans
                  i18nKey="municipalities_t4"
                  components={{ italic: <i />, strong: <strong /> }}
                />
              </div>
            </Grid>

            <Grid item className="box3" xs={12} sm={12} md={8}>
              <div className="arrinfo">
                <ul>
                  <li>
                    <Trans
                      i18nKey="municipalities_t4_p1"
                      components={{ italic: <i />, strong: <strong /> }}
                    />
                  </li>
                  <li>
                    <Trans
                      i18nKey="municipalities_t4_p2"
                      components={{ italic: <i />, strong: <strong /> }}
                    />
                  </li>
                </ul>
              </div>
            </Grid>

          </Grid>

          <Grid container className="box1">

            <Grid item className="box2" xs={12} sm={12} md={12}>
              <div className="arr_bottom">
                <div className="white">
                  <Trans
                    className="white"
                    i18nKey="municipalities_t5"
                    components={{ italic: <i />, strong: <strong /> }}
                  />
                </div>

              </div>
            </Grid>
          </Grid>

        </Box>






        {/* 
      <div className="arrinfo">
        <ul>
          <li>
              Kontakaufnahmen
          </li>          
        </ul>
      </div>
*/}

        {/* 
        {t('municipalities_advice_1')}
        <Box sx={{ paddingBottom: 2 }} />
        • {t('municipalities_advice_2')}
        <Box sx={{ paddingBottom: 2 }} />
        • {t('municipalities_advice_3')}
        <Box sx={{ paddingBottom: 2 }} />
        • {t('municipalities_advice_4')}
        <Box sx={{ paddingBottom: 2 }} />
        • {t('municipalities_advice_5')}
        <Box sx={{ paddingBottom: 2 }} />
        • {t('municipalities_advice_6')}
        <Box sx={{ paddingBottom: 2 }} />
        • {t('municipalities_advice_7')}
        */}



      </Box>
    </>

  );
}